export default __webpack_public_path__ + "static/media/logo.555fe2fa.png";